import { cloneDeep } from 'lodash'

import { joinURLPath } from '@sigma-frontend-libs/commons'

import { getHammerTime, globalErrorHandler, request, services } from '@/utils'

import render from './render'

const defaultDate = {
  date: undefined,
  time: getHammerTime()
}

export default {
  name: 'RunDelayPause',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      loading: false,

      changeableDate: cloneDeep(defaultDate)
    }
  },

  computed: {
    computedDate() {
      if (this.changeableDate.date) {
        return new Date(this.changeableDate.date + 'T' + this.changeableDate.time)
      }

      return null
    }
  },

  methods: {
    async updateTask(id, state, startsAt = null) {
      try {
        this.loading = true
        await request.update(joinURLPath(services.tasks, id), {
          body: {
            state,
            startsAt
          }
        })
        this.addSnackbar({
          text: this.getTranslate(`${services.tasks}.snackbars.updated`),
          type: 'success'
        })
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
